import { Theme } from "../../../../components/constants";


export default {

    headerContainer: {
        display: "flex",
        flexDirection:"column",
        alignItems: "center",
        columnGap: "60px",
        marginBottom: "40px",
        marginTop:"20px",
        justifyContent: "center",
    },

    headerText: {
        display: "flex",
        alignItems: "center",
        columnGap: "10px"
    },

    viewingYear: {
        display: "flex",
        alignItems: "center",
    },

    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    date: {
        margin: "0px 8px 0px 8px",
    },

    checkboxLabel: {
        marginLeft: "8px"
    },

    actionButtonsContainer: {
        margin: "0px 0px 20px",
        display: "flex",
        alignItems: "center",
        columnGap: "20px"
    },

    button: {
        padding: "6px 22px"
    },

    createFormBtn: {
        marginRight: "10px"
    },

    gridContainer: {
        marginTop: "0px"
    },

    searchFilter: {
        display: "flex",
        columnGap: "20px",
    },

    filter: {
        display: "flex",
        columnGap: '15px',
        alignItems: "center",
    },

    actionButtons: {
        display: "flex",
        columnGap: "10px",
        alignItems: "center"
    },

    actionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #262626",
        borderRadius: "80px",
        padding: "6px 22px",
    },

    actionDropdownLabel: {
        marginRight: "15px"
    },

    actionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        top: "30px",
        left: "-70px"
    },

    buttonContainer: {
        display: "flex",
        columnGap: "10px",
        justifyContent: "end",
        marginBottom: "40px"
    },

    okButton: {
        padding: "6px 30px",
        marginTop: "30px"
    },

    modalBody: {
        padding: "0px 20px 25px 40px"
    },
    button1094c: {
        padding: "0px 10px",
    },
    btnColorRed: {
        background: Theme.DANGER,
    },
    btnColorGreen: {
        background: Theme.SUCCESS,
    },
    label1094cStyle: {
        marginRight: "10px",
    },
    flexRowWithGap: {
        display: 'flex', 
        alignItems: 'center',
        gap: '5px'
    }
}